module.exports = __webpack_public_path__ + "img/35.2dbcd9f5.webp";